import { Watermark as AntWatermark, WatermarkProps } from 'antd';

export const Watermark = AntWatermark;

export type { WatermarkProps };
